import { useEffect, useState } from 'react'

import { createDynamicComponent } from '@/utils/factoryUtil'

import styles from './Disqus.module.scss'

type Props = {
  identifier: string
  slug: string
  title: string
}

/*
  Don't render Disqus on non-article pages or outside of the production environment

  When Disqus renders, it associates the current URL with the identifier (post ID)
  Unfortunately the URL seems to be read *not* from props, but from the browser, opening us up to wrong URLs

  https://help.disqus.com/en/articles/1717138-why-are-the-same-comments-showing-up-on-multiple-pages
*/
const HOSTNAMES = ['edhrec.com', 'localhost']

const DiscussionEmbed = createDynamicComponent({
  loader: () => import('disqus-react'),
  name: 'DiscussionEmbed',
})

const canEmbed = () =>
  HOSTNAMES.includes(window.location.hostname) && /^\/articles\/[^/]+$/.test(window.location.pathname) // Check for /articles/[slug]

export const Disqus = ({ identifier, slug, title }: Props) => {
  // Seeded false so the first client render matches SSR, then checked for real on mount
  const [enabled, setEnabled] = useState(false)

  // eslint-disable-next-line react-hooks/set-state-in-effect
  useEffect(() => setEnabled(canEmbed()), [])

  if (!enabled) return null

  return (
    <div className={styles.container}>
      <DiscussionEmbed
        config={{
          identifier,
          language: 'en',
          title,
          url: `https://edhrec.com/articles/${slug}`,
        }}
        shortname='edhrec'
      />
    </div>
  )
}
